const FilteredTickets = (tickets, tagsFilter, user, connectionsAndQueues, status, onlyGroups) => {

    const filteredTickets = tickets.filter(ticket => {
        const { Contact, userId } = ticket;

        // Filtrar se é Grupo caso esteja marcado
        if (onlyGroups == true && (ticket?.isGroup == false || ticket?.Contact?.isGroup == false)) return false;

        // Filtrar status
        if (status && ['open', 'pending', 'closed'].includes(status) && ticket.status != status) return false;

        // Filtrar etiquetas
        const hasTags = Contact?.tagsId && Array.isArray(Contact?.tagsId) && Contact.tagsId.length > 0;
        const hasTagsFilter = tagsFilter && Array.isArray(tagsFilter) && tagsFilter.length > 0;

        const hasMatchingTag = hasTags
            ? Contact.tagsId.some(tag => tagsFilter.includes(tag.id)) && hasTagsFilter
            : hasTagsFilter && tagsFilter.includes(null);  // Verifica se null ou array vazio está no filtro

        if (!hasMatchingTag) return false;

        // Verificar atendente somente se não for finalizado
        if (ticket.status != 'closed' && userId && userId !== user.id) return false;

        // Verificar configuração de individualHistory
		if (user?.profile != 'admin' && ticket?.Queue?.individualHistoric == true && ticket?.Queue?.distribution == 'automatic') {
			if (ticket?.userId && ticket.userId != null && ticket.userId != user.id) return false;
		}

        // Verificar conexões e filas
        if (!connectionsAndQueues || !Array.isArray(connectionsAndQueues) || connectionsAndQueues.length == 0) return false;

        // identificar conexão
        const conn = connectionsAndQueues.find(c => c.connectionId == ticket.whatsappId);
        if (!conn || !conn?.queueIds || !Array.isArray(conn.queueIds) || conn.queueIds.length == 0) return false;
        // identificar fila
        if (conn.queueIds.includes(ticket.queueId) == false) return false;

        return true;
    });

    const removeDuplicated = (tickets) => {
        const showed = new Set();

        return tickets.filter(ticket => {
            if (showed.has(ticket.id)) {
                return false; // Já vimos esse ID, então é duplicado
            }

            showed.add(ticket.id);
            return true;
        });
    }

    return removeDuplicated(filteredTickets);
};

export default FilteredTickets;